export const MEETING_ID_LENGTH = 8
export const PASSCODE_LENGTH = 6
export const VR_PASSCODE_LENGTH = 5

export const AUTH_TYPES = {
  EVENT_CODE: "eventCode",
  PAIRING_CODE: "pairingCode",
} as const
